import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

import { Box, Paper, Typography, Stack, Avatar } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Parallax } from 'react-parallax';
import Button from '@mui/material/Button';
import { Bloodtype } from '@mui/icons-material';

import AboutSecTwo from '../../section/activity/AboutSecTwo';
import Counter from '../../section/activity/Counter';
import AboutThree from '../../section/activity/AboutThree';
import ServiceExcellence from '../../section/activity/ServiceExcellence';
import MainActivity from '../../section/activity/MainActivity';
import WhatClientSay from '../../section/activity/WhatClientSay';
import WeAreMember from '../../section/activity/WeAreMember';
import { activityApi, activityContentService } from '../../service/Activity.service';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#fb5d36'),
    backgroundColor: '#f97150',
    borderRadius: 3,
    padding: '0 22px',
    lineHeight:'44px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    fontSize:'14px',
    fontFamily: 'Montserrat',
    boxShadow:'none',
    '@media (max-width:768px)': {
      lineHeight:'34px',
      fontSize:'11px',
      padding: '0 15px' ,
    },
    '&:hover': {
      backgroundColor: '#d04726',
    },
  }));

const Activity = () => {
    const [activityList, setActivityList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingTwo, setLoadingTwo] = useState(true);
    const [content, setContent] = useState({});

    useEffect(() => {
        getActivitys();
        getActivityContent();
    }, []);

    const getActivitys = async () => {
        const listActivity = await activityApi.listActivity();
        if (listActivity.status === 200 && listActivity.data.status === 200 && listActivity.data.success === true) {
            await setActivityList(listActivity.data.data);
            await setLoading(false);
        }
    };
    const getActivityContent = async () => {
        const result = await activityContentService();
        if (result.status === 200) {
            setContent(result.data.data);
            await setLoadingTwo(false);
        }
    };
    return (
        <>
            {loading || loadingTwo ? (
                <div className="preload">
                <div className="logo-container">
                <img src="../images/loader.svg" alt="" className="logo" />
                 
                </div>
            </div>
            ) : (
                <>
                    <Box className='aboutBan relative'>
                        <Parallax
                            bgImage={`${process.env.REACT_APP_HOST_IMAGE}image/activities/${content?.content?.banner_img}`}
                            bgImageAlt=''
                            strength={100}
                        >
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '600px',
                                    maxWidth: '1170px',
                                    width: '100%',
                                    margin: '0 auto',
                                }}
                                className='aboutBanSlogan relative ph-80'
                            >
                                <Grid
                                    container spacing={{ xs: 2, md: 3 , lg: 3 }} padding={{xs: 2, md: 2 , lg: 3}} alignItems={'center'}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                    }}
                                >
                                    <Grid item xs={12} md>
                                        <Typography
                                            variant='h2'
                                            sx={{
                                                fontSize: '50px',
                                                fontWeight: 'bold',
                                                padding: '0',
                                                color: '#f97150',
                                            }}
                                        >
                                            {content?.content?.title}
                                        </Typography>
                                        <Typography
                                            variant='body2'
                                            sx={{
                                                color: '#fff',
                                                fontSize: '15px',
                                            }}
                                        >
                                            {parse(content?.content?.sub_title ?? '')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={'auto'}>
                                        <Link to={`/contact`} className='themeButton'>
                                            Contact Us
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Parallax>
                    </Box>
                    <AboutSecTwo content={content} />
                    <Counter />
                    <AboutThree content={content} />
                    <ServiceExcellence />
                    <MainActivity activity={activityList} />
                    <WhatClientSay />
                    <WeAreMember />
                </>
            )}
        </>
    );
};

export default Activity;
